module.exports = __webpack_public_path__ + "static/loja_3-1ccc10bd75520e8dbb9fe8c936c3e6f6.png";